module.exports = __webpack_public_path__ + "static/contactinbio-2573c5048d8adef6ca64b787f80173c9.png";